import { UserRole } from '@lysi-web/shared-types';

/**
 * The route a user lands on after sign-in / sign-up, or when "going home"
 * from somewhere they can't be (e.g., the Unauthorized page).
 *
 * Kept in one place so the post-auth landing page, role-gated redirects,
 * and the Unauthorized "Go to Dashboard" button can't drift apart again —
 * the drift was the cause of the Unauthorized redirect loop for
 * PHARMACY_MANAGER / PHARMACY_EMPLOYEE.
 */
export function roleHome(role?: string): string {
  switch (role) {
    case UserRole.CUSTOMER:
      return '/buscar';
    case UserRole.DOCTOR:
      return '/doctor/dashboard';
    case UserRole.SUPER_ADMIN:
      return '/admin/dashboard';
    case UserRole.PHARMACY_MANAGER:
    case UserRole.PHARMACY_EMPLOYEE:
      return '/pharmacy/orders';
    case UserRole.CONSULTANT:
      return '/consultant/dashboard';
    default:
      return '/';
  }
}

/**
 * The medications lookup route for a role. The lookup page, its print view and
 * the cart drawer are mounted under both /doctor and /consultant, so every link
 * between them has to be role-relative — a hard-coded /doctor path sent every
 * consultant to /unauthorized, since /doctor/* is gated to DOCTOR alone.
 */
export function medicationsHome(role?: string): string {
  return role === UserRole.CONSULTANT ? '/consultant/medications' : '/doctor/medications';
}
